import { Trans } from "@lingui/react";
import { Icon } from "../Icon.tsx";

export const ImageMissing = () => {
  return (
    <div
      className="flex flex-col w-full h-full justify-center items-center"
      style={{ aspectRatio: "4/3", objectFit: "contain", backgroundColor: "#f1f9ff" }}
    >
      <Icon name="Image" size="56px" />
      <p>
        <Trans id="imageGallery.imageMissing" message="Image missing" />
      </p>
    </div>
  );
};
